import { IElement } from "core-integration/src/store/elements/types";
import { IPlayer } from "core-integration/src/store/player/types";
import i18n from "../i18n";

const PLAYMAKER_BASE = import.meta.env.VITE_PLAYMAKER_BASE;
const ENTRY_SEASON = "allsvenskan-2026";

export const getPlaymakerUrl = (
  player: IPlayer | null,
  utmContentType: string,
  element?: IElement | null,
) => {
  const locale = i18n.language === "sv" ? "sv" : "en";
  const utmTags = `utm_source=ism_app&utm_medium=internal_referral&utm_campaign=allsvenskan_2026&utm_content=${utmContentType}`;

  const queryParams: string[] = [];
  if (player) {
    queryParams.push(`entryId=${player.id}`);
    queryParams.push(`entryTeamId=${player.entry}`);
  }

  if (element) queryParams.push(`octaId=${element.code}`);
  queryParams.push(`entrySeason=${ENTRY_SEASON}`);
  queryParams.push(utmTags);
  queryParams.push(`lang=${locale}`);

  return `${PLAYMAKER_BASE}/ism/click/?${queryParams.join("&")}`;
};

export const getPlaymakerNewsParams = (
  player: IPlayer | null,
  utmContentType: string,
) => {
  const utmTags = `utm_source=ism_app&utm_medium=internal_referral&utm_campaign=allsvenskan_2026&utm_content=${utmContentType}`;

  const queryParams: string[] = [];
  if (player) {
    queryParams.push(`entryId=${player.id}`);
    if (player.entry != null) {
      queryParams.push(`entryTeamId=${player.entry}`);
    }
  }
  queryParams.push(utmTags);

  return queryParams.join("&");
};
